// the mean URL for API
// export const MAIN_URL = `http://localhost:8000/api/v1`;
export const MAIN_URL = `https://crm.boxbyld.tech/api/v1`;

//Login API
export const LOGIN_URL = `${MAIN_URL}/admin/auth/login`;

//users API
export const USERS_URL = `${MAIN_URL}/admin/users`;

//panels
export const PANELS_URL = `${MAIN_URL}/admin/panels`;

//create panels
export const CREATE_PANELS_URL = `${MAIN_URL}/admin/create`;

//delete Panels
export const DELETE_PANELS_URL = `${MAIN_URL}/admin/delete`;

//uitilty url
export const UTILITY_PROVIDERS_URL = `${MAIN_URL}/admin/utility-providers`;

// state
export const STATE_URL = `${MAIN_URL}/countries/country/231`;

//get leads
export const LEADS_URL = `${MAIN_URL}/admin/leads`;

//get roles
export const ROLES_URL = `${MAIN_URL}/admin/roles`;

//business api
export const BUSINESS_URL = `${MAIN_URL}/admin/businesses`;

//installer API
export const INSTALLER_URL = `${MAIN_URL}/admin/installers`;

// Solar Contract API
export const SOLARCONTRACT_URL = `${MAIN_URL}/admin/solar-contracts`;

// Vendors API
export const VENDORS_URL = `${MAIN_URL}/admin/vendor`;

// Vendors State API
export const VENDORS_STATE_URL = `${MAIN_URL}/admin/state_vendor`;

// Designers API
export const DESIGNERS_URL = `${MAIN_URL}/admin/designers`;

// Designers Licens API
export const DESIGNERS_LICENS_URL = `${MAIN_URL}/admin/designer/licens`;

export const SEND_MAIL_URL = `${MAIN_URL}/general/notification`;

// Solutions Card Analysis
export const SOLUTIONS_URL = `${MAIN_URL}/admin/solutions`;

// EverSign Documents Card Analysis
export const EVERSIGN_DUCOMENTS_URL = `${MAIN_URL}/admin/eversign_docoments`;

export const ADDERS_CATEGORIES_API = `${MAIN_URL}/admin/adders-category`;

const INSTALLER_PORTAL = "https://tech.boxbyld.tech/api";

export const INSTALLER_URL_PORTAL = `${INSTALLER_PORTAL}/admin/installers`;
export const INSTALLER_URL_PORTAL2 = `${INSTALLER_PORTAL}/admin/installer`;

const INSTALLER_PORTAL_V2 = "https://secure.paytabs.sa/payment";
// Adders Portal API

export const ADDERS_API = `${INSTALLER_PORTAL}/admin/adders`;
export const ADDERS_API_V2 = `${INSTALLER_PORTAL}/admin/adders`;


export const MESSAGES_PORTAL_URL = `https://msg.boxbyld.tech/api`;

// PDF Contract Singed
export const PDF_URL_SIGNED = `https://crm.boxbyld.tech/profiles/`;

export const APC_ADDER = `${INSTALLER_PORTAL}/admin`;

const TICKETS_PROTAL = 'https://pmb.boxbyld.tech';
export const TICKETS_URL = `${TICKETS_PROTAL}/api/tickets`;
